import * as React from "react";
import { Button } from "@blueprintjs/core";
import { StoresContext } from "../../pages/_app";
import { useContext, useState } from "react";

interface AnnotationDownloadButtonProps {
  disabled: boolean;
  genomeName: string;
  genomeUuid?: string;
  searchTerm: string;
  annotationUuids: string[];
  assemblyUuid?: string;
}

const AnnotationDownloadButton = (props: AnnotationDownloadButtonProps) => {
  const rootStore = useContext(StoresContext);
  const [disabled, setDisabled] = useState<boolean>(props.disabled);

  const onClick = () => {
    setDisabled(true);
    rootStore.userStore.tryToDoGuardedAction(() => {
      return rootStore.genomeStore.downloadAnnotationsCSV(
        props.genomeName,
        props.searchTerm,
        props.annotationUuids,
        props.genomeUuid,
        props.assemblyUuid
      );
    }, false);
    setDisabled(props.disabled);
  };

  return (
    <div className="annotation-download">
      <Button onClick={onClick} disabled={disabled}>
        Download Table CSV
      </Button>
    </div>
  );
};

export default AnnotationDownloadButton;
